import { useEffect } from 'react';
import LOGO_ICON_SRC from './logoAsset';

const useFavicon = () => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = LOGO_ICON_SRC;
  }, []);
};

export default useFavicon;
export { LOGO_ICON_SRC };
